import { Icon } from './Icons.jsx';
import Avatar from './Avatar.jsx';

export function StepperMobile({ steps, current, user, onProfileClick }) {
  return (
    <div className="stepper-mob">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', letterSpacing: '0.08em', textTransform: 'uppercase', fontFamily: 'var(--font-display)' }}>
            Passo {current + 1} de {steps.length}
          </div>
          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--brand-primary)', fontFamily: 'var(--font-display)', marginTop: 2 }}>
            {steps[current]}
          </div>
        </div>
        {onProfileClick && (
          <Avatar user={user} size={34} onClick={onProfileClick}/>
        )}
      </div>
      <div style={{ display: 'flex', gap: 4 }}>
        {steps.map((_, i) => (
          <div key={i} style={{ flex: 1, height: 4, borderRadius: 2, background: i <= current ? 'var(--brand-primary)' : 'var(--border)', transition: 'background 0.2s' }}/>
        ))}
      </div>
    </div>
  );
}

export function MobHeader({ title, onBack, trailing }) {
  return (
    <div className="mob-header">
      {onBack && (
        <button className="mob-back" onClick={onBack} aria-label="Voltar">
          <Icon.chevL size={20}/>
        </button>
      )}
      <div className="mob-header-title">{title}</div>
      {trailing}
    </div>
  );
}

export function FooterBar({ onBack, onNext, canNext = true, nextLabel = 'Continuar', hint, loading = false }) {
  return (
    <div style={{ padding: '12px 16px 20px', background: 'var(--white)', borderTop: '1px solid var(--border)', position: 'sticky', bottom: 0, zIndex: 10 }}>
      {hint && <div style={{ fontSize: 11, color: 'var(--text-muted)', textAlign: 'center', marginBottom: 8 }}>{hint}</div>}
      <div style={{ display: 'flex', gap: 10 }}>
        {onBack && (
          <button className="btn btn-outline" onClick={onBack} style={{ flex: '0 0 auto', width: 'auto', padding: '0 18px' }}>
            <Icon.chevL size={16}/>
          </button>
        )}
        <button className="btn btn-primary" onClick={onNext} disabled={!canNext || loading} style={{ flex: 1 }}>
          {loading ? <Icon.loader size={18} color="var(--white)"/> : <>{nextLabel} <Icon.arrowR size={18} color="var(--white)"/></>}
        </button>
      </div>
    </div>
  );
}
